var exports = {
  "kL": "xa15a2ab7--a60e44--container",
  "Sl": "xa15a2ab7--a60e44--image",
  "p2": "xa15a2ab7--a60e44--text-info",
  "nn": "xa15a2ab7--a60e44--icon-button-wrapper",
};

module.exports = exports;
